import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  CommonUtility,
  DataService, DateUtility,
  EmploymentPlan,
  EmploymentPlanSummary,
  ServerConstantsService, WpEtEnrollment,
  WpPerson,
  ClientInformation, Role, WpReferral, Task, MIN_CHAR_SEARCH_LENGTH,
  CaseNotes
} from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { HttpClient } from '@angular/common/http';
import { EnrollmentSumary } from '../shared/model/EnrollmentSumary';
import { ProviderOffice } from '../shared/model/ProviderOffice';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ProviderService } from '../provider-management/provider-management.service';
import * as $ from 'jquery';
import { GridOptions } from "ag-grid/main";
import * as moment from 'moment';
import { EDIT_BTN, VIEW_BTN, DOUBLE_ROW_HEADER, DELETE_BTN, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, AgGridUtility, RequestVO } from '../shared';
import { EtEnrollment } from '../shared/model/et-enrollment.model';

@Component({
  selector: 'app-enrollment-summary',
  templateUrl: './enrollment-summary.component.html',
  styleUrls: ['./enrollment-summary.component.scss']
})
export class EnrollmentSummaryComponent implements OnInit {

  serverConstants: any;
  sharedData: any;
  refData: any;
  firstTime: Boolean = true;
  userActionNotificationsMap: any;
  closureReasonJson: any;
  closureReasonMap: any;
  employmentPlans: EmploymentPlan[];
  employmentPlan: EmploymentPlan;
  employmentPlanSummary: EmploymentPlanSummary;
  enrollmentSummary: EnrollmentSumary;
  enrollmentEndDt: any = null;
  context: any;
  tabToNextCell:any;

  empPlanStatusMap: any;
  empPlanStatusArray: any[];

  enrollmentList: WpEtEnrollment[] = [];
  wpPerson: WpPerson;
  referralId = '';
  wpPersonId = '';
  providersMap: any[];

  providerName: any;
  empPlanStatus: any;
  providerOffices: ProviderOffice[] = [];
  providerId;
  enrollment;
  selected:Boolean = false;

  empStatusCd = '';
  isEmpStatusDisabled: Boolean = false;
  isCaseClosure = 'N';
  closureReasonCd: any = null;
  closureReasonArray;
  isUniverse = false;
  isCaseClosedVisible: Boolean = false;
  isCaseClosedDisabled: Boolean = false;
  roles: Role[];

  isAuthorizedUser: Boolean = false;
  isReadOnlyUser: Boolean = false;
  isCaseClosed: Boolean = false;

  triggerReasons = ['CC', 'DO', 'NC', 'CN', 'LC'];

  enrollmentSummaryRequest: EnrollmentSumary;
  maxClosureDate: any;

  disablePrintCorrespondence = true;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('yes') yes: ElementRef;
  @ViewChild('no') no: ElementRef;
  @ViewChild('caseClosure') caseClosure: ElementRef;
  @ViewChild('closureRsn') closureRsn: ElementRef;
  @ViewChild('saveBtn') saveBtn: ElementRef;

  clientInfo: ClientInformation;


  // Elastic Search constiables

  elasticSuggestions = new BehaviorSubject<any>(null);
  suggestions: any = [];
  results: any = [];
  caseAssignmentFlag = false;


  MIN_CHAR_SEARCH_LENGTH = MIN_CHAR_SEARCH_LENGTH;
  selectCounty = false;
  countyId = 0;
  isChangeDetected: boolean;
  counties: any = null;
  countiesRT: any = null;

  isReActivateCase;
  reActivateReasonArray;
  reActivateReasonCd;
  serviceError:Boolean = false;

  loaderFocusAssProv: Boolean = false;

  gridOptions: GridOptions;
  gridApi:any;

  // US #14_01 | POIGAI
  assingedServiceCounty: any;
  serviceCountySuggestions: any = [];
  serviceCountySelected: Boolean = false;
  columnDefs: any;
  countyCds: any;
  loaderFocusAssCounty: Boolean = false;
  selectedServiceCountyId: number;
  prevServiceCountyName: any;
  prevProviderName: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private providerService: ProviderService,
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('CLINF') === undefined) {
      this.router.navigate(['/task']);
    }
    this.gridOptions = <GridOptions>{};
  }

 
  ngOnInit() {
    this.caseAssignmentFlag = false;
    this.dataService.globalAccess = true;
    this.sharedData = this.dataService.getSharedDataObject();
    this.employmentPlanSummary = new EmploymentPlanSummary();
    this.employmentPlan = new EmploymentPlan();
    this.enrollmentSummary = new EnrollmentSumary();
    this.enrollmentSummary.etEnrollment = new WpEtEnrollment();
    this.referralId = this.sharedData.get('referralId');

    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.providersMap = this.sharedData.get('providers');
    this.isUniverse = this.sharedData.get('UNIVERSE_SEARCH');
    this.providerId = this.sharedData.get('providerId');
    this.roles = this.sharedData.get('roles');

    const closureReason = this.data.getValueFromSharedDataMap('CASE_CLOSURE_REASON');
    console.log('closureReason : ' + closureReason);
    this.closureReasonJson = this.commonUtil.createNativeMapFromList(closureReason);
    this.closureReasonMap = this.commonUtil.createMapFromList(closureReason);


    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.enrollment = this.sharedData.get('etEnrollment');
      this.employmentPlanSummary.etEnrollmentId = Number(this.enrollment.id);
    }
    this.parseRefTableData();
    // US #14_01 | POIGAI
    this.countyCds = this.data.getValueFromSharedDataMap('COUNTIES');

    if (!this.isUniverse) {
      this.loadEnrollmentsList();
      this.getColumnDefinitions();
    }

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Enrollment Id',
        field: 'id',
        width: 130,

      },
      {
        headerName: 'Referral Id',
        field: 'referral.id',
        width: 130,

      },
      /*{
        headerName: 'Enrollment Start Date',
        field: 'enrollmentStartDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        width: 160,

      },*/
      {
        headerName: 'Enrollment End Date',
        field: 'enrollmentEndDt',
        filter: "agDateColumnFilter",
        //valueFormatter: this.formatDates,
        /*filterParams: {
          comparator: this.filterDates,
        },*/
        width: 160,
        valueGetter: this.getEnrollmentEndDate,
      },
      /*{
        headerName: 'Closure Reason', field: 'closureReasonCd',
        refData: this.closureReasonJson, width: 130, valueGetter: this.getClosureReason,
      },*/
      {
        headerName: 'Referred Date',
        field: 'referredDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        width: 160,
      },
      { headerName: 'Action', field: '', cellRenderer: this.getEditButton, width: 120,
        suppressFilter: true,
        suppressSorting: true }

    ];

    this.context = {
      component: this,
    };

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getClosureReason(params) {

    const that = params.context.component;
    if(params.data.closureReasonCd != null && params.data.closureReasonCd != undefined && params.data.closureReasonCd != "") {
      return that.closureReasonMap.get(params.data.closureReasonCd);
    } 
    else{
      return "";
    }
    
  }

  getEnrollmentEndDate(params) {
    if(params.data.enrollmentEndDt != null && params.data.enrollmentEndDt != undefined && params.data.enrollmentEndDt != "") {
      return moment(params.data.enrollmentEndDt).format('MM/DD/YYYY');
    } 
    else{
      return "Current";
    }
    
  }

  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const viewImage = VIEW_BTN ;
    const editImage = EDIT_BTN;
    
    if(params.data.enrollmentEndDt != null && params.data.enrollmentEndDt != undefined){
      element.innerHTML = viewImage;
    } else {
      element.innerHTML = editImage;
    }

    element.setAttribute("tabindex","0");

    element.addEventListener('click', () => {
      console.log("params.data.referral.id: " + params.data.referral.id);
      that.dataService.addValueToSharedDataMap('selectedEnrollmentId', params.data.id);
      that.dataService.addValueToSharedDataMap('selectedReferralId', params.data.referral.id);
      that.dataService.addValueToSharedDataMap('selectedEnrollmentEndDt', params.data.enrollmentEndDt);
      
      that.router.navigate(['/task/personSummary/enrollmentDetail']);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
        console.log("params.data.referral.id" + params.data.referral.id);
        that.dataService.addValueToSharedDataMap('selectedEnrollmentId', params.data.id);
        that.dataService.addValueToSharedDataMap('selectedReferralId', params.data.referral.id);
        that.dataService.addValueToSharedDataMap('selectedEnrollmentEndDt', params.data.enrollmentEndDt);
      
        that.router.navigate(['/task/personSummary/enrollmentDetail']);
      }
      /*else if((!event.shiftKey && event.keyCode===9) && (params.rowIndex === (that.caseNotes.length -1))){
        event.preventDefault();
        setTimeout(() => that.header.nativeElement.focus(), 0);
        that.header.nativeElement.click();
      }*/
    });
    return element;
  }

  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }

    // We create a Date object for comparison against the filter date
    // const dateStr = (cellValue.split(" "))[0];
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  loadEnrollmentsList() {
    console.log('Loading all enrollments...');
    this.http.post<EtEnrollment[]>(this.serverConstants.COMMON_SERVER_API_URL + '/wp-et-enrollment/list', {
      'personId': Number(this.wpPersonId),
      'referralId': Number(this.referralId)
    }).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Enrollment Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data.length > 0) {
            this.enrollmentList = data;
          } else {
            this.enrollmentList = [];
          }
        }
      }, response => {
        this.notificationService.error('Enrollment Summary', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  formatDates(params) {
    if (!params.value) {
      return null;
    }

    // //const dateStr = (params.value.split(" "))[0];
    // const dateStr = (params.value.split(" "))[0];
    const dateParts = params.value.split('/');

    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }

  parseRefTableData() {
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(
      this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.empPlanStatusArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_PLAN_STATUS');
    this.closureReasonArray = this.data.getValueFromSharedDataMap('CASE_CLOSURE_REASON');
    this.reActivateReasonArray = this.data.getValueFromSharedDataMap('CASE_RE_ACTIVATION_REASON');
    this.empPlanStatusMap = this.commonUtil.createMapFromList(this.empPlanStatusArray);
    this.countiesRT = this.data.getValueFromSharedDataMap('COUNTIES');
  }

  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/enrollment-summary/enrollment-summary.component.ts